module.exports = __webpack_public_path__ + "img/syper_128px_without.e37fc65e.png";